import React, { Component } from 'react';
import { Error } from '../../../views';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    console.error('ERROR', error);
    // Zaktualizuj stan, aby następny render pokazał zastępcze UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // Możesz także zalogować błąd do zewnętrznego serwisu raportowania błędów
    console.error('ERROR', error);
    // history.push('/error');
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      // history.push('/error');
      // Możesz wyrenderować dowolny interfejs zastępczy.
      return <Error />;
    } else return children;
  }
}

export default ErrorBoundary;
